var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrderSideNav = function SvgOrderSideNav(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 32,
    fill: "none",
    viewBox: "0 0 52 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 24.539C49.5 30 37.998 35.5 24.498 28 10.999 20.5.129 37.539.128 24.539c0-13 14.478-32.224 35.516-21.316 13.5 7 16.855 15.855 15.355 21.316z",
    fill: "none",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 25.5L26 28l3.5-2.5 3 2.5H36V4H16v24h4l2.5-2.5zm-3.328.5l1.914-1.914 1.198-1.198 1.379.984L26 25.542l2.337-1.67 1.257-.897 1.186.989L33.224 26H34V6H18v20h1.172z",
    fill: props.fill,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: props.fill,
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M26 11h4M22 11h1M26 15h4M22 15h1M26 19h4M22 19h1"
  }));
};
export default SvgOrderSideNav;